import AttendanceIconActive from "assets/img/Sidebar/Repositioning/Attendance_Filled_Active.svg";
import AttendanceIconFilled from "assets/img/Sidebar/Repositioning/Attendance_filled.svg";
import AttendanceIconLine from "assets/img/Sidebar/Repositioning/Attendance_line.svg";
import ClientsIconActive from "assets/img/Sidebar/Repositioning/Customer_Filled_Active.svg";
import ClientsIconFilled from "assets/img/Sidebar/Repositioning/Customer_filled.svg";
import ClientsIconLine from "assets/img/Sidebar/Repositioning/Customer_line.svg";
import DashboardIconFilled from "assets/img/Sidebar/Repositioning/Dashboard_Filled.svg";
import DashboardIconActive from "assets/img/Sidebar/Repositioning/Dashboard_Filled_Active.svg";
import DashboardIconLine from "assets/img/Sidebar/Repositioning/Dashboard_Line.svg";
import GPSTrackIconActive from "assets/img/Sidebar/Repositioning/GPS_tracking_Filled_Active.svg";
import GPSTrackIconFilled from "assets/img/Sidebar/Repositioning/GPS_tracking_filled.svg";
import GPSTrackIconLine from "assets/img/Sidebar/Repositioning/GPS_tracking_line.svg";
import IntegrationsIconFilled from "assets/img/Sidebar/Repositioning/Integration_Filled.svg";
import IntegrationsIconActive from "assets/img/Sidebar/Repositioning/Integration_Filled_Active.svg";
import IntegrationsIconLine from "assets/img/Sidebar/Repositioning/Integration_Line.svg";
import InvoiceIconFilled from "assets/img/Sidebar/Repositioning/Invoice_Filled.svg";
import InvoiceIconActive from "assets/img/Sidebar/Repositioning/Invoice_Filled_Active.svg";
import InvoiceIconLine from "assets/img/Sidebar/Repositioning/Invoice_Line.svg";
import MembersIconFilled from "assets/img/Sidebar/Repositioning/Member_Filled.svg";
import MembersIconActive from "assets/img/Sidebar/Repositioning/Member_Filled_Active.svg";
import MembersIconLine from "assets/img/Sidebar/Repositioning/Member_Line.svg";
import OfficesIconActive from "assets/img/Sidebar/Repositioning/Office_Filled_Active.svg";
import OfficesIconFilled from "assets/img/Sidebar/Repositioning/Office_filled.svg";
import OfficesIconLine from "assets/img/Sidebar/Repositioning/Office_line.svg";
import OrganizationsIconFilled from "assets/img/Sidebar/Repositioning/Organization_Filled.svg";
import OrganizationsIconActive from "assets/img/Sidebar/Repositioning/Organization_Filled_Active.svg";
import OrganizationsIconLine from "assets/img/Sidebar/Repositioning/Organization_Line.svg";
import PayrollIconActive from "assets/img/Sidebar/Repositioning/Payroll_Filled_Active.svg";
import PayrollIconLine from "assets/img/Sidebar/Repositioning/Payroll_Line.svg";
import PayrollIconFilled from "assets/img/Sidebar/Repositioning/Payroll_filled.svg";
import QuickActionsIconFilled from "assets/img/Sidebar/Repositioning/Quick_Actions_Filled.svg";
import QuickActionsIconActive from "assets/img/Sidebar/Repositioning/Quick_Actions_Filled_Active.svg";
import QuickActionsIconLine from "assets/img/Sidebar/Repositioning/Quick_Actions_Line.svg";
import RouteOptimizationIconActive from "assets/img/Sidebar/Repositioning/Route_Filled_Active.svg";
import RouteOptimizationIconFilled from "assets/img/Sidebar/Repositioning/Route_filled.svg";
import RouteOptimizationIconLine from "assets/img/Sidebar/Repositioning/Route_line.svg";
import SchedulesIconFilled from "assets/img/Sidebar/Repositioning/Scheduling_Filled.svg";
import SchedulesIconActive from "assets/img/Sidebar/Repositioning/Scheduling_Filled_Active.svg";
import SchedulesIconLine from "assets/img/Sidebar/Repositioning/Scheduling_Line.svg";
import SettingsIconFilled from "assets/img/Sidebar/Repositioning/Settings_Filled.svg";
import SettingsIconActive from "assets/img/Sidebar/Repositioning/Settings_Filled_Active.svg";
import SettingsIconLine from "assets/img/Sidebar/Repositioning/Settings_Line.svg";
import TasksIconFilled from "assets/img/Sidebar/Repositioning/Task_Filled.svg";
import TasksIconActive from "assets/img/Sidebar/Repositioning/Task_Filled_Active.svg";
import TasksIconLine from "assets/img/Sidebar/Repositioning/Task_Line.svg";
import TimesheetIconActive from "assets/img/Sidebar/Repositioning/Timesheet_Filled_Active.svg";
import TimesheetIconFilled from "assets/img/Sidebar/Repositioning/Timesheet_filled.svg";
import TimesheetIconLine from "assets/img/Sidebar/Repositioning/Timesheet_line.svg";
import WorkOrderIconFilled from "assets/img/Sidebar/Repositioning/Work_order_Filled.svg";
import WorkOrderIconActive from "assets/img/Sidebar/Repositioning/Work_order_Filled_Active.svg";
import WorkOrderIconLine from "assets/img/Sidebar/Repositioning/Work_order_Line.svg";
import closeBlueIcon from "assets/img/icons/close_blue.svg";
import hamburgerBlueIcon from "assets/img/icons/hamburger_blue.svg";
import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { CommonImage } from "../../styledComponents/common";
import {
  ActiveRouteTab,
  BottomNavContainer,
  MenuButton,
  MenuLabel,
  QuickActionsButton,
  QuickActionsLabel,
  RouteIcon,
  RouteLabel,
} from "./bottomNavBarStyles";

const iconMap = {
  quickActionsIcon: {
    filled: QuickActionsIconFilled,
    active: QuickActionsIconActive,
    line: QuickActionsIconLine,
  },
  dashboardIcon: {
    filled: DashboardIconFilled,
    active: DashboardIconActive,
    line: DashboardIconLine,
  },
  gpsTrackIcon: {
    filled: GPSTrackIconFilled,
    active: GPSTrackIconActive,
    line: GPSTrackIconLine,
  },
  timesheetIcon: {
    filled: TimesheetIconFilled,
    active: TimesheetIconActive,
    line: TimesheetIconLine,
  },
  clockInOutIcon: {
    filled: AttendanceIconFilled,
    active: AttendanceIconActive,
    line: AttendanceIconLine,
  },
  officesIcon: {
    filled: OfficesIconFilled,
    active: OfficesIconActive,
    line: OfficesIconLine,
  },
  teamsIcon: {
    filled: OfficesIconFilled,
    active: OfficesIconActive,
    line: OfficesIconLine,
  },
  tasksIcon: {
    filled: TasksIconFilled,
    active: TasksIconActive,
    line: TasksIconLine,
  },
  schedulesIcon: {
    filled: SchedulesIconFilled,
    active: SchedulesIconActive,
    line: SchedulesIconLine,
  },
  projectIcon: {
    filled: WorkOrderIconFilled,
    active: WorkOrderIconActive,
    line: WorkOrderIconLine,
  },
  invoiceIcon: {
    filled: InvoiceIconFilled,
    active: InvoiceIconActive,
    line: InvoiceIconLine,
  },
  WorkOrderIcon: {
    filled: WorkOrderIconFilled,
    active: WorkOrderIconActive,
    line: WorkOrderIconLine,
  },
  clientsIcon: {
    filled: ClientsIconFilled,
    active: ClientsIconActive,
    line: ClientsIconLine,
  },
  membersIcon: {
    filled: MembersIconFilled,
    active: MembersIconActive,
    line: MembersIconLine,
  },
  payrollIcon: {
    filled: PayrollIconFilled,
    active: PayrollIconActive,
    line: PayrollIconLine,
  },
  routeOptimizationIcon: {
    filled: RouteOptimizationIconFilled,
    active: RouteOptimizationIconActive,
    line: RouteOptimizationIconLine,
  },
  integrationsIcon: {
    filled: IntegrationsIconFilled,
    active: IntegrationsIconActive,
    line: IntegrationsIconLine,
  },
  organizationsIcon: {
    filled: OrganizationsIconFilled,
    active: OrganizationsIconActive,
    line: OrganizationsIconLine,
  },
  settingsIcon: {
    filled: SettingsIconFilled,
    active: SettingsIconActive,
    line: SettingsIconLine,
  },
};

const findActiveRoute = (routes, pathname) => {
  if (!routes) return null;
  for (const route of routes) {
    if (route.redirect) continue;
    if (route.collapse && route.views) {
      const found = findActiveRoute(route.views, pathname);
      if (found) return { name: route.name, icon: route.icon };
    } else if (route.layout === "/user" && route.path) {
      const fullPath = route.layout + route.path;
      if (pathname === fullPath || pathname.startsWith(fullPath + "/")) {
        return { name: route.name, icon: route.icon };
      }
    }
  }
  return null;
};

const CREATE_ACTION_MAP = {
  "/user/jobs": { label: "Create Job", path: "/user/create-job" },
  "/user/job-details": { label: "Create Job", path: "/user/create-job" },
  "/user/edit-job": { label: "Create Job", path: "/user/create-job" },
  "/user/job-approval": { label: "Create Job", path: "/user/create-job" },
  "/user/tasks": { label: "Create Task", path: "/user/create-task" },
  "/user/task-details": { label: "Create Task", path: "/user/create-task" },
  "/user/edit-task": { label: "Create Task", path: "/user/create-task" },
  "/user/task-approval": { label: "Create Task", path: "/user/create-task" },
  "/user/customers": { label: "Add Customer", path: "/user/add-customer" },
  "/user/customer-details": {
    label: "Add Customer",
    path: "/user/add-customer",
  },
  "/user/add-customer": { label: "Add Customer", path: "/user/add-customer" },
  "/user/edit-customer": { label: "Add Customer", path: "/user/add-customer" },
  "/user/project": { label: "Create Project", path: "/user/create-project" },
  "/user/details-project": {
    label: "Create Project",
    path: "/user/create-project",
  },
  "/user/edit-project": {
    label: "Create Project",
    path: "/user/create-project",
  },
  "/user/create-project": {
    label: "Create Project",
    path: "/user/create-project",
  },
  "/user/members": { label: "Invite Member", path: "/user/member-invitation" },
  "/user/member-details": {
    label: "Invite Member",
    path: "/user/member-invitation",
  },
  "/user/member-invitation": {
    label: "Invite Member",
    path: "/user/member-invitation",
  },
  "/user/member-invitationCSV": {
    label: "Invite Member",
    path: "/user/member-invitation",
  },
  "/user/member-add-update": {
    label: "Invite Member",
    path: "/user/member-invitation",
  },
  "/user/teams": { label: "Add Team", path: "/user/add-team" },
  "/user/team-details": { label: "Add Team", path: "/user/add-team" },
  "/user/add-team": { label: "Add Team", path: "/user/add-team" },
  "/user/invoices": { label: "Create Invoice", path: "/user/create-invoice" },
  "/user/create-invoice": {
    label: "Create Invoice",
    path: "/user/create-invoice",
  },
  "/user/edit-invoice": {
    label: "Create Invoice",
    path: "/user/create-invoice",
  },
  "/user/shift-and-schedule": {
    label: "Create Team Schedule",
    action: "OPEN_CREATE_SHIFT_MODAL",
  },
};

const BottomNavBar = ({
  onMenuClick,
  menuOpen,
  routes,
  isMobile = false,
  isTablet = false,
  onQuickActionsToggle = () => {},
  quickActionsAnchorRef,
  selectedOrganization,
}) => {
  const location = useLocation();
  const history = useHistory();
  const role = selectedOrganization?.role;

  const orgType = selectedOrganization?.type || "operation";

  const activeRouteInfo = useMemo(() => {
    return findActiveRoute(routes, location.pathname);
  }, [routes, location.pathname]);

  const activeIcon = activeRouteInfo?.icon;
  const activeName = activeRouteInfo?.name || "Dashboard";
  const activeIconSrc = activeIcon
    ? iconMap[activeIcon]?.active ||
      iconMap[activeIcon]?.filled ||
      iconMap[activeIcon]?.line
    : DashboardIconActive;

  // Determine dynamic creation action
  // For shift-and-schedule, "operation" type should show Quick Actions panel (2 options)
  // For non-operation (e.g., service), on shift-and-schedule show Create Job, not Create Team Schedule.
  const isShiftSchedule = location.pathname === "/user/shift-and-schedule";
  let dynamicAction = null;

  if (isShiftSchedule) {
    dynamicAction =
      orgType === "operation"
        ? null
        : { label: "Create Job", path: "/user/create-job" };
  } else {
    dynamicAction = CREATE_ACTION_MAP[location.pathname];
  }

  const quickActionText = useMemo(() => {
    if (dynamicAction) return dynamicAction.label;
    return isMobile ? "+" : "Quick Actions";
  }, [dynamicAction, isMobile]);

  const quickActionAriaLabel = useMemo(() => {
    if (dynamicAction) return dynamicAction.label;
    return isMobile ? "Open Quick Actions" : "Open Quick Actions panel";
  }, [dynamicAction, isMobile]);

  const handleQuickActionClick = () => {
    if (dynamicAction) {
      if (dynamicAction.action === "OPEN_CREATE_SHIFT_MODAL") {
        window.dispatchEvent(new CustomEvent("OPEN_CREATE_SHIFT_MODAL"));
      } else if (dynamicAction.path) {
        history.push(dynamicAction.path);
      }
    } else {
      onQuickActionsToggle();
    }
  };

  return (
    <BottomNavContainer>
      {/* Left pill — active route */}
      <ActiveRouteTab>
        <RouteIcon src={activeIconSrc} alt={activeName} />
        <RouteLabel>{activeName}</RouteLabel>
      </ActiveRouteTab>

      {/* Middle pill — quick actions, visible on mobile/tablet only */}
      {(isMobile || isTablet) && (role === "owner" || role === "admin") && (
        <QuickActionsButton
          ref={quickActionsAnchorRef}
          onClick={handleQuickActionClick}
          aria-label={quickActionAriaLabel}
          type="button"
        >
          <QuickActionsLabel>{quickActionText}</QuickActionsLabel>
        </QuickActionsButton>
      )}

      {/* Right pill — toggles between Menu (hamburger) and Close (✕) */}
      <MenuButton onClick={onMenuClick}>
        <MenuLabel>Menu</MenuLabel>
        {menuOpen ? (
          <CommonImage
            src={closeBlueIcon}
            alt="close"
            style={{ width: "14px", height: "14px" }}
          />
        ) : (
          <CommonImage
            src={hamburgerBlueIcon}
            alt="menu"
            style={{ width: "16px", height: "10px" }}
          />
        )}
      </MenuButton>
    </BottomNavContainer>
  );
};

export default BottomNavBar;
